import React from 'react';
import PropTypes from 'prop-types';

/**
 * EmptyState des Design-Systems (siehe MODERNIZATION_PLAN.md P1.3).
 *
 * Vorbild: NotificationsPage (pages/NotificationsPage.js) — bislang die
 * einzige Stelle mit echtem CTA-Button statt reinem Hinweistext.
 * Vereinheitlicht Icon + Titel + Text + optionale Aktion für Listen ohne Inhalt.
 *
 * size="md" (Standard): ganzseitiger Empty-State (Notifications, Chat, Journal).
 * size="sm": kompakter Platzhalter innerhalb einer Sektion/Liste (z.B. ein
 * leerer Abschnitt unter mehreren auf derselben Seite).
 *
 * <EmptyState icon={Bell} title="Keine Benachrichtigungen" text="Du bist auf dem neuesten Stand!"
 *   action={<Button variant="secondary" onClick={refresh}>Aktualisieren</Button>} />
 */
const SIZES = {
  md: { wrap: 'p-12', icon: 'h-16 w-16 mb-4', title: 'text-lg font-medium' },
  sm: { wrap: 'p-8', icon: 'h-8 w-8 mb-3', title: 'text-sm font-medium' },
};

const EmptyState = ({ icon: Icon, title, text, action, size = 'md', className = '' }) => {
  const s = SIZES[size] || SIZES.md;
  return (
    <div className={`${s.wrap} text-center ${className}`}>
      {Icon && <Icon className={`mx-auto text-muted-foreground/40 ${s.icon}`} aria-hidden="true" />}
      {title && <p className={`text-foreground ${s.title}`}>{title}</p>}
      {text && <p className="mt-2 text-sm text-muted-foreground">{text}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
};

EmptyState.propTypes = {
  icon: PropTypes.elementType,
  title: PropTypes.node,
  text: PropTypes.node,
  action: PropTypes.node,
  size: PropTypes.oneOf(['md', 'sm']),
  className: PropTypes.string,
};

export default EmptyState;
